module.exports = __webpack_public_path__ + "static/media/DEENCONNECT_MasjidBaitusSalam_5.aee29ccf.jpeg";